import React from 'react';
import { useStyles } from '../../../lib/styles';

import toastStyles from './Toast_styles';
import Typography from '../../presentational/Typography';

interface ToastAction {
  text: string;
  onClick: () => any;
}

export interface ToastProps {
  action?: ToastAction;
  children: React.ReactNode;
}

const Toast = ({ action, children }: ToastProps) => {
  const styles = useStyles(toastStyles());

  return (
    <Typography color={'white'} linkColor={'accent'}>
      <div className={styles.container}>
        <span>{children}</span>
        {action && <a onClick={action.onClick}>{action.text}</a>}
      </div>
    </Typography>
  );
};

export default Toast;
